module.exports = "/_next/static/chunks/images/police-traffic-stop-b41bd8c43c56db8f12e6b8871b8a474b.jpg";